import { Buffer } from "buffer";
import { IconCollection } from "components/Icon/IconCollection";
import { ResourceConfig } from "config/config";
import {
    deleteActionSignature,
    DeleteListAction,
    deletePermanentlyActionSignature,
    downloadActionSignature,
    duplicateActionSignature,
    exportActionSignature,
    moveToLocationActionSignature,
    PermanentlyDeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";
import {
    commentsTab,
    logsTab,
    logsTabKey,
    metadataTab,
} from "containers/Resources/screens/ResourcesSingle/constants";
import { buildSimpleColumn } from "containers/Search/components/SearchTabs/columns";
import resource from "./resource";

const resourceName = "file";

const config: ResourceConfig = {
    label: "File",
    icon: IconCollection.fileOutline,
    resourceName,
    resourceClass: "resource",
    defaultActiveTab: logsTabKey,
    layout: [
        { partial: "pageHeaderForm" },
        { partial: "form" },
        {
            partial: "tabs",
            config: {
                tabs: [logsTab.tab, metadataTab.tab, commentsTab.tab],
                content: [logsTab.content, metadataTab.content, commentsTab.content],
            },
        },
    ],
    graphql: {
        resource: resourceName,
        resourceBody: `
            ${resource.graphql.resourceBody}
            content_size_bytes
            content_type
        `,
        resourceBodyListing: `
            ${resource.graphql.resourceBody}
            content_size_bytes
            content_type
        `,
        createVariables: `
            ${resource.graphql.createVariables(resourceName)}
            $content: String
        `,
        createQuery: `
            ${resource.graphql.createQuery(resourceName)}
            content: $content
        `,
        updateVariables: `
            ${resource.graphql.updateVariables(resourceName)}
            $content: String,
        `,
        updateQuery: `
            ${resource.graphql.updateQuery(resourceName)}
            content: $content,
        `,
    },
    actions: {
        shown: [downloadActionSignature],
        hidden: [
            duplicateActionSignature,
            exportActionSignature,
            moveToLocationActionSignature,
            deleteActionSignature,
            deletePermanentlyActionSignature,
        ],
    },
    listActions: {
        shown: [],
        hidden: [
            { key: "delete", action: DeleteListAction },
            { key: "deletePermanently", action: PermanentlyDeleteListAction },
        ],
    },
    additionalColumns: (setNewValue) => [
        {
            label: "Content size in bytes",
            key: "content_size_bytes",
            shown: true,
            sortable: true,
            dto: (value: any) => {
                const content = <div>{value.content_size_bytes}</div>;
                return buildSimpleColumn(
                    content,
                    setNewValue
                        ? () =>
                              setNewValue({
                                  field: "content_size_bytes",
                                  value: value.content_size_bytes,
                              })
                        : undefined
                );
            },
        },
    ],
    form: [
        {
            name: "content_size_bytes",
            component: "value",
            fieldProps: {
                label: "Content size in bytes",
            },
        },
        {
            name: "content",
            component: "switchContent",
            fieldProps: {
                label: "Content",
                lang: "text",
                isReadOnly: false,
                hiddenContentTooltip:
                    "Could not display large content. To see the content, please download the file.",
            },
            submitDto: (value: any) => Buffer.from(value, "binary").toString("base64"),
        },
    ],
    formDTO: {
        initialValueDTO: (data: any) => {
            const content =
                data?.content !== undefined
                    ? Buffer.from(data?.content, "base64").toString("binary")
                    : undefined;
            return { ...data, content };
        },
    },
};
export default config;
